//different color of first 3 numbers of tel.nbr
$(document).ready(function () {
    var content = $('.header-call-nbr').text();
    $('.header-call-nbr').html('<span class="header-call-nbr-first">' + content.substring(0, 4) + '</span>' + content.substring(4, content.length));
});

//hide +420 of tel-number in footer-contact
$(document).ready(function () {
    var content = $('.footer-contact-info-tel').text();
    $('.footer-contact-info-tel').text(content.substring(4, content.length));
});

//Form error/success message
$(document).on('click', '.form-submit', function () {
    var prm = Sys.WebForms.PageRequestManager.getInstance();
    prm.add_endRequest(showFeedbackText);

    function showFeedbackText() {
        if ($('.form-row').has('.Error').length > 0) {
            $('.form-success-submit').css('display', 'none');
            $('.form-error-submit').css('display', 'flex');
        } else {
            $('.form-success-submit').css('display', 'flex');
            $('.form-error-submit').css('display', 'none');
        }
    }
});

//info - show content on click
$(document).ready(function () {
    $('.debt-item h3').click(function () {
        $(this).toggleClass('active');
        if (window.innerWidth >= 1024) {
            $(this).children('.debt-item-more').toggle();
            $(this).children('.debt-item-less').toggle();
        }
        $(this).parent().children('p').toggle(200);
    });
});

//faq - show on click
$(document).ready(function () {
    $('.faq-item h2').click(function () {
        $(this).toggleClass('active');
        $(this).parent().children('p').toggle(200);
    });
});

//debt-process
$(document).ready(function () {
    var mobile;
    if ($(window).innerWidth() >= 1024) {
        mobile = false;
        desktopViewTransform();
    } else {
        mobile = true;
        mobileViewTransform();
    }

    $(window).resize(function () {
        if (mobile && $(window).innerWidth() >= 1024) {
            desktopViewTransform();
            mobile = false;
        }
        if (!mobile && $(window).innerWidth() < 1024) {
            mobileViewTransform();
            mobile = true;
        }
    });

    $(window).scroll(function () {
        if (!mobile) {
            showOnScroll();
        }
    });

    $('.debt-process-title').click(function () {
        if (mobile && hasText($(this).siblings('p'))) {
            $(this).siblings('p').toggle(200);
            $(this).children('.process-more, .process-less').toggle();
        }
    });

    function showOnScroll() {
        var windowHeight = $(window).height();
        var scrollPosition = $(window).scrollTop();
        $('.debt-process-item p').each(function () {
            var elementTopPosition = $(this).offset().top;
            var elementHeight = $(this).height();
            if (scrollPosition <= elementTopPosition &&
                (scrollPosition + windowHeight) >= (elementTopPosition + elementHeight) &&
                hasText($(this))) {
                $(this).css("opacity", "1");
            }
            else {
                $(this).css("opacity", "0");
            }
        });
    }

    function hasText(obj) {
        return obj.text().trim().length > 0;
    }

    function desktopViewTransform() {
        $('.debt-process-item p').css("opacity", "0");
        $('.debt-process-item p').show();
        $('.debt-process-title').children('.process-more, .process-less').hide();

        $('.debt-process-title .item-index').each(function () {
            var number = parseInt($(this).text(), 10);
            if (number % 2 == 0) {
                $(this).parent().parent().children().each(function () {
                    $(this).addClass('switched');
                });
            }
        });


        $('.debt-process-item p').each(function () {
            if (!hasText($(this))) {
                $(this).parent().addClass('no-text');
                $(this).parent().children('.debt-process-title').addClass('no-text');
            }
        });

        showOnScroll();
    }

    function mobileViewTransform() {
        $('.debt-process-item p').css("opacity", "1");
        $('.debt-process-item p').hide();
        $('.debt-process-title').removeClass('switched no-text');
        $('.debt-process-item').removeClass('no-text');

        $('.debt-process-title').each(function () {
            if (hasText($(this).siblings('p'))) {
                $(this).children('.process-more').show();
            } else {
                $(this).children('.process-more').hide();
            }
        });
    }
});

//mobile-menu toggle
$(document).ready(function () {
    $('#nav-mobile-toggle').on('click', function () {
        $('.main-nav').toggleClass('active');
        $('.nav-mobile-header').toggleClass('active');
    });
    $('.nav-mobile-header img').on('click', function () {
        $('.main-nav').removeClass('active');
        $('.nav-mobile-header').removeClass('active');
    });
});


$(document).ready(function () {
    //transformation - triangle to 100% of parent height 
    calcTriangles();
    $(window).resize(calcTriangles);

    function calcTriangles() {
        $('.debt-item h3, .faq-item h2').each(function () {
            var halfHeight = $(this).outerHeight() / 2;
            $(this).children('.triangle').css({ "border-top": halfHeight + "px solid transparent", "border-bottom": halfHeight + "px solid transparent" });
        });
    }

    //calculator
    if ($('.calc-key span').is(":visible")) {
        var txtClose = $('.calc-key span').data("close");
        var txtOpen = $('.calc-key span').data("open");
    }

    //open calculator
    $('#calcOpener').click(function () {
        $('.calc-key').click();
    });

    $('.calc-key').click(function () {
        $(this).parent().toggleClass('active');

        if ($(this).parent().hasClass('active')) {
            $('.calc-key span').text(txtClose);
        } else {
            $('.calc-key span').text(txtOpen);
        }
    });

    //mobile open calculator
    $('.btn-calc').click(function () {
        $('.calc-wrapper').toggleClass('active');

        if ($('.calc-wrapper').hasClass('active')) {
            $('.calc-key span').text(txtClose);
        } else {
            $('.calc-key span').text(txtOpen);
        }
    });
});